<template>
<div class="header shadow-sm">
  <!-- Top First Bar -->
  <div class="top-bar-first bg-white text-dark py-1 border-bottom">
    <div class="container d-flex justify-content-between align-items-center">
      <router-link :to="orgUrl" class="brand-title font-weight-bold text-dark mb-0 h5 text-decoration-none">
        Retail Orders - {{  this.orgName }}
      </router-link>

      <div class="auth-section">
        <div v-if="!isLoggedIn" style="cursor: pointer;" class="d-inline-block">
          <img src="../../public/btn_google_signin_dark_normal_web.png" height="32" @click.prevent="userGoogleLogin()" alt="Sign in with Google">
        </div>
        <a v-else @click.prevent="logout" class="li-pointer text-dark small font-weight-bold text-decoration-none">
          {{ currentUser.email }} : Logout
        </a>
      </div>
    </div>
  </div>

  <!-- Top Second Bar -->
  <nav class="top-bar-second navbar navbar-expand navbar-dark bg-dark py-2">
    <div class="container d-flex justify-content-between align-items-center">
      <div class="d-none d-sm-block flex-1" style="min-width: 140px;"></div>
      <ul class="navbar-nav mx-auto d-flex align-items-center">
        <li class="nav-item mr-3">
          <a class="nav-link li-pointer font-weight-bold text-light px-2" @click.prevent="handleOrderEntry">
            Entry
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link li-pointer font-weight-bold text-light px-2" @click.prevent="handleOrderReport">
            Report
          </a>
        </li>
      </ul>
      <div class="text-right flex-1" style="min-width: 140px;">
        <router-link :to="cartUrl" class="btn btn-success btn-sm font-weight-bold" tag="button">
          Order <span class="badge badge-light ml-1">{{ numItems }} (INR {{ cartValue }})</span>
        </router-link>
      </div>
    </div>
  </nav>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { firebaseAuth } from '../config/firebaseConfig';
import { signInWithPopup, GoogleAuthProvider } from "firebase/auth";

export default {
  data() {
    return {
      isNavOpen: false, 
      isLoading: false
    };
  },
  computed: {
    ...mapGetters(['isLoggedIn', 'currentUser', 'cartValue', 'cartItemList', 'orgId', 'location', 'orgName']),

    orgUrl() {
      var oId = this.orgId || '1';
      var loc = this.location || '1';
      return ("/" + oId + "/" + loc);
    },
    cartUrl() {
      var oId = this.orgId || '1';
      var loc = this.location || '1';
      return ("/cart/" + oId + "/" + loc);
    },
    reportUrl() {
      var oId = this.orgId || '1';
      var loc = this.location || '1';
      return ("/report/" + oId + "/" + loc);
    },
    numItems() {
      return this.cartItemList.reduce((total, item) => {
        total += item.quantity;
        return total;
      }, 0);
    },
  },
  methods: {
    ...mapActions(['authStatusChange', 'loginWithGoogle', 'logout', 'addMessage', 'clearMessage', 'clearCart', 'clearPayment', 'setItemLevel']),

    toggleNavbar() {
      this.isNavOpen = !this.isNavOpen;
    },

    handleOrderEntry() {
      this.clearCart();
      this.clearPayment();
      var itemLevel = 1;
      this.setItemLevel({ itemLevel });
      var targetOrgId = this.orgId || '1';
      var targetLocation = this.location || '1';
      this.$router.push('/' + targetOrgId + '/' + targetLocation);
    },

    handleOrderReport() {
      this.clearCart();
      this.clearPayment();
      var itemLevel = 1;
      this.setItemLevel({ itemLevel });
      this.$router.push(this.reportUrl);
    },

    userGoogleLogin() {
      var self = this;
      this.clearCart();
      this.clearPayment();
      
      const provider = new GoogleAuthProvider();
      provider.setCustomParameters({
        prompt: 'select_account'
      });

      signInWithPopup(firebaseAuth, provider)
        .then(() => {
          self.authStatusChange();
        }).catch((error) => {
          self.addMessage({
            messageClass: 'danger',
            message: error.message,
          });
        });
    },
  }
};
</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100vw;
}

.brand-title:hover {
  color: #000;
  opacity: 0.8;
}

.li-pointer {
  cursor: pointer;
}

.li-pointer:hover {
  cursor: pointer;
  opacity: 0.8;
}
</style>
